import { useState, useLayoutEffect, useRef } from "react";
import Linkify from "linkify-react";
import { intl } from "LocaleWrapper";
import { Button } from "@cofano/cck";
import { Typography, Box } from "@mui/material";

interface ExpandableTextProps {
	text?: string | null;
	lines?: number;
}

const ExpandableText = ({ text, lines = 5 }: ExpandableTextProps) => {

	const [ isExpanded, setIsExpanded ] = useState<boolean>(false);
	const [ needsCollapse, setNeedsCollapse ] = useState<boolean>(false);
	const textRef = useRef<HTMLParagraphElement>(null);

	useLayoutEffect(() => {
		const element = textRef.current;
		if (element) {
			const isOverflowing = element.scrollHeight > element.clientHeight;
			setNeedsCollapse(isOverflowing);
		}
	}, [ text, lines ]);


	if (!text) {
		return <Typography sx={{ fontSize: "small" }}>{"-"}</Typography>;
	}

	return (
		<Box sx={{ width: "100%" }}>
			<Typography
				ref={textRef}
				sx={{
					whiteSpace: "pre-wrap",
					wordBreak: "break-word",
					fontSize: "small",
					display: "-webkit-box",
					WebkitBoxOrient: "vertical",
					WebkitLineClamp: isExpanded ? "none" : lines,
					overflow: "hidden",
				}}>
				<Linkify
					options={{
						target: "_blank",
						rel: "noreferrer noopener",
						validate: {
							email: false,
						},
					}}>
					{text}
				</Linkify>
			</Typography>

			{needsCollapse && (
				<Box mt={1}>
					<Button
						size="small"
						variant="text"
						onClick={() => setIsExpanded(!isExpanded)}>
						{isExpanded ? intl.formatMessage({ id: "SHOW_LESS" }) : intl.formatMessage({ id: "SHOW_MORE" })}
					</Button>
				</Box>
			)}
		</Box>
	);
};

export default ExpandableText;
